import Cookies from 'js-cookie';
/**
 * Creates config for cookie.
 * @param time How long the cookie should stay valid for.
 * @param timeUOM Unit of measure of the time (days or seconds).
 * @param domain the domain where the cookie is to be set.
 * @returns The cookie configuration to be used when creating a cookie.
 */
function createCookieConfig(time, timeUOM = 'd', domain) {
    const config = { path: '/' };
    if (time) {
        let timeToAdd = time * 1000;
        if (timeUOM === 'd')
            timeToAdd *= 24 * 60 * 60;
        const date = new Date(Date.now());
        date.setTime(date.getTime() + timeToAdd);
        config.expires = date;
    }
    if (domain)
        config.domain = domain;
    return config;
}
/**
 * Creates a cookie.
 * @param cookieName Name of the cookie to create.
 * @param value The value to store in that cookie.
 * @param time How long the cookie should stay valid for.
 * @param timeUOM Unit of measure of the time (days or seconds).
 * @param domain the domain where the cookie is to be set.
 */
export function createCookie(cookieName, value, time, timeUOM = 'd', domain) {
    const config = createCookieConfig(time, timeUOM, domain);
    Cookies.set(cookieName, value, config);
}
export function getCookie(cookieName) {
    return Cookies.get(cookieName);
}
export function deleteCookie(cookieName, domain) {
    const config = domain ? createCookieConfig(undefined, undefined, domain) : undefined;
    Cookies.remove(cookieName, config);
}
